import { TokensContracts } from "@/config/tokens-contracts";
import { useWalletCollectionStore } from "@/store/wallet-collection";

export const getAttachedApe = (tokenId, tokenType) => {
  const tokenInfo = TokensContracts[tokenType];
  if (!tokenInfo) return;
  const walletCollection = useWalletCollectionStore();
  const attachedApeId =
    walletCollection.apeAttachmentsMap[
      `${tokenInfo.contractAddress}_${tokenId}`
    ];
  if (!attachedApeId) return;
  return walletCollection.apes.find((ape) => ape.id === attachedApeId);
};
